import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

import LogoImage from "images/logowhite.svg";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";
import { ReactComponent as LinkedInIcon } from "images/linkedin-icon.svg";
import { ReactComponent as InstagramIcon } from "images/instagram-icon.svg";

const Container = tw.div`relative bg-secondary-900 text-white  py-20 `;
const Content = tw.div` mx-auto relative z-10`;
const SixColumns = tw.div` px-8 sm:px-16 xl:px-24 flex flex-wrap text-center sm:text-left justify-center sm:justify-start md:justify-between -mt-12`;

const Column = tw.div`sm:px-0 w-full sm:w-1/4 md:w-auto mt-12`;

const ColumnHeading = tw.h5`uppercase font-bold  pl-4`;

const LinkList = tw.ul`mt-6 text-sm font-medium`;
const LinkListItem = tw.li`mt-3 pl-4`;
const Link = tw.a`border-b-2 border-transparent hocus:border-gray-700 pb-1 transition duration-300`;

const SubscribeNewsletterColumn = tw(Column)`text-center lg:text-left w-full! lg:w-auto! mt-20 lg:mt-12`;
const SubscribeNewsletterContainer = tw.div`max-w-sm mx-auto lg:mx-0 `;
const SubscribeText = tw.p`mt-2 lg:mt-6 text-sm font-medium text-gray-600`;
const SubscribeForm = tw.form`mt-4 lg:mt-6 text-sm sm:flex max-w-xs sm:max-w-none mx-auto sm:mx-0`;
const Input = tw.input`bg-gray-300 px-6 py-3 rounded sm:rounded-r-none border-2 sm:border-r-0 border-gray-400 hover:border-primary-500 focus:outline-none transition duration-300 w-full`;
const SubscribeButton = tw(PrimaryButtonBase)`mt-4 sm:mt-0 w-full sm:w-auto rounded sm:rounded-l-none px-8 py-3`;

const Divider = tw.div`my-16 border-b border-gray-100 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center flex justify-center`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-32`;
const LogoText = tw.h5` text-xl font-buzzz  tracking-wider text-orange-600`;

const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-8 md:mt-0 font-medium text-gray-500`;

const SocialLinksContainer = tw.div`mt-8 md:mt-0 flex justify-center sm:justify-start mx-auto`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-900 text-gray-100 hover:bg-gray-700 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;



export default () => {
  return (
    <div>


      <Container>


        <Content>

          <SixColumns>
            <Column>

              <LogoContainer>
                <LogoImg src={LogoImage} />

              </LogoContainer>

              <LinkList>

                <LinkListItem >
                  Take your sport community to the<br /> next level with Buzza
                </LinkListItem>
                <LinkListItem>
                  <SocialLinksContainer>
                    <SocialLink href="https://www.facebook.com/Buzza-352248298537684" target={'_blank'}>
                      <FacebookIcon />
                    </SocialLink>
                    <SocialLink href="https://www.instagram.com/getbuzza/" target={'_blank'}>
                      <InstagramIcon />
                    </SocialLink>
                    <SocialLink href="https://www.twitter.com/getbuzza_" target={'_blank'}>
                      <TwitterIcon />
                    </SocialLink>
                    <SocialLink href="https://www.linkedin.com/company/buzza-sports/" target={'_blank'}>
                      <LinkedInIcon />
                    </SocialLink>
                  </SocialLinksContainer>
                </LinkListItem>

              </LinkList>
            </Column>
            <Column>
              <ColumnHeading>Legal</ColumnHeading>
              <LinkList>
                {/* <LinkListItem>
                  <Link href="#">GDPR</Link>
                </LinkListItem> */}
                <LinkListItem>
                  <Link href="privacy">Privacy Policy</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="terms">Terms and conditions</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="#">Cookies</Link>
                </LinkListItem>
                {/* <LinkListItem>
                  <Link href="#">Disclaimer</Link>
                </LinkListItem> */}
              </LinkList>
            </Column>
            <Column>
              <ColumnHeading>Company</ColumnHeading>
              <LinkList>
                <LinkListItem>
                  <Link href="#">For Businesses & Organisations</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="#">For Individuals</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="#">Benefits</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="#">Support</Link>
                </LinkListItem>


              </LinkList>
            </Column>
            <Column>
              <ColumnHeading>Socials</ColumnHeading>
              <LinkList>
                <LinkListItem>
                  <Link href="https://www.instagram.com/getbuzza/">Instagram</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="https://www.facebook.com/Buzza-352248298537684">Facebook</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="https://www.twitter.com/getbuzza_">Twitter</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="https://www.linkedin.com/company/buzza-sports/">LinkedIn</Link>
                </LinkListItem>
              </LinkList>
            </Column>
            <Column>
              <ColumnHeading>Contact</ColumnHeading>
              <LinkList>
                <LinkListItem>
                  <Link href="#">Lagos, Nigeria</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="#">+2348114570714</Link>
                </LinkListItem>
                <LinkListItem>
                  <Link href="#">play@buzza.app</Link>
                </LinkListItem>

              </LinkList>
            </Column>
            <Column></Column>





          </SixColumns>

          <Divider />

          <ThreeColRow>

            <CopywrightNotice>&copy; {new Date().getFullYear()} Buzza. All Rights Reserved.</CopywrightNotice>

          </ThreeColRow>
        </Content>
      </Container>
    </div>
  );
};
